export default "/images/2c37e2041ba9ee0afe2776d9d9d4d8c7.avif";